import React from 'react';

const Introduction = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        Welcome to our Privacy Policy. This document explains how we collect, use, and protect your personal information. 
        We are committed to ensuring the privacy and security of all our users, with special attention to emotional and 
        mental health-related data. This policy is designed to be transparent and comprehensive, helping you understand 
        your rights and our responsibilities regarding your personal information.
      </p>
    </div>
  );
};

export default Introduction;